<template>
  <WebChapterTemplate
    page-title="《中国新闻传播学年鉴》"
    section-label="传播与平台"
    section-route="/lanhu_chuanboyupingtai"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
  >
    <section class="page-section page-section--intro">
      <div class="intro-grid">
        <figure class="book-strip">
          <img :src="images.yearbooks" alt="《中国新闻传播学年鉴》2015、2016、2017 年卷书影" />
          <figcaption>《中国新闻传播学年鉴》2015、2016、2017 年卷书影</figcaption>
        </figure>

        <div class="intro-copy">
          <h2 class="section-title">《中国新闻传播学年鉴》</h2>
          <p class="body-text">
            创办于 2015 年，是记录我国新闻传播学术研究成果的大型资料性年刊，也是我国第一部新闻传播学科学术年鉴。该刊全面记录、真实反映我国新闻传播学研究取得的成果，深度呈现中国新闻传播研究的学术全景，由中国社会科学出版社出版，目前已连续出版 3 卷。
          </p>
        </div>
      </div>
    </section>

    <section class="page-section">
      <figure class="feature-figure">
        <img :src="images.launch2014" alt="2014 年 7 月《中国新闻传播学年鉴》创刊启动研讨会在北京香山饭店召开" />
        <figcaption>2014 年 7 月，《中国新闻传播学年鉴》创刊启动研讨会在北京香山饭店召开</figcaption>
      </figure>
    </section>

    <section class="page-section page-section--conference">
      <div class="conference-grid conference-grid--top">
        <figure class="conference-figure">
          <img :src="images.beijing2016" alt="2016 年 4 月首届《中国新闻传播学年鉴》编辑出版研讨会在北京召开" />
          <figcaption>2016 年 4 月，新闻与传播研究所与中国社会科学出版社联合举办的首届《中国新闻传播学年鉴》编辑出版研讨会在北京召开</figcaption>
        </figure>
        <figure class="conference-figure">
          <img :src="images.xiamen2018" alt="2018 年 6 月《中国新闻传播学年鉴》第三届编辑出版研讨会在厦门大学召开" />
          <figcaption>2018 年 6 月，《中国新闻传播学年鉴》第三届编辑出版研讨会在厦门大学召开</figcaption>
        </figure>
      </div>

      <figure class="conference-figure conference-figure--wide">
        <img :src="images.zhengzhou2017" alt="2017 年 7 月《中国新闻传播学年鉴》第二届编辑出版研讨会在郑州大学召开" />
        <figcaption>2017 年 7 月，《中国新闻传播学年鉴》第二届编辑出版研讨会在郑州大学召开</figcaption>
      </figure>
    </section>
  </WebChapterTemplate>
</template>

<script>
import WebChapterTemplate from '@/components/WebChapterTemplate.vue';

export default {
  name: 'NewLanhuZhongguoxinwenchuanboxuenianjian',
  components: {
    WebChapterTemplate
  },
  data() {
    return {
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png'),
      images: {
        yearbooks: require('./assets/p66-yearbooks-2015-2017.jpg'),
        launch2014: require('./assets/p66-launch-seminar-2014.jpg'),
        beijing2016: require('./assets/p67-beijing-2016.jpg'),
        xiamen2018: require('./assets/p67-xiamen-2018.jpg'),
        zhengzhou2017: require('./assets/p67-zhengzhou-2017.jpg')
      }
    };
  }
};
</script>

<style scoped>
.page-section {
  margin-bottom: 48px;
}

.page-section:last-child {
  margin-bottom: 0;
}

.page-section--intro {
  padding-bottom: 18px;
  border-bottom: 1px solid rgba(179, 145, 101, 0.18);
}

.intro-grid {
  display: grid;
  grid-template-columns: minmax(360px, 0.95fr) minmax(0, 1.1fr);
  gap: 30px;
  align-items: center;
}

.section-title {
  margin: 0 0 16px;
  color: #f25c19;
  font-size: 24px;
  line-height: 1.4;
  font-weight: 700;
  font-family: 'Songti SC', 'STSong', 'Noto Serif SC', serif;
}

.body-text {
  margin: 0;
  color: #231f20;
  font-size: 15px;
  line-height: 1.9;
  text-align: justify;
  text-indent: 2em;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.book-strip,
.feature-figure,
.conference-figure {
  margin: 0;
}

.book-strip img,
.feature-figure img,
.conference-figure img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 4px;
  box-shadow: 0 8px 24px rgba(45, 33, 16, 0.08);
}

.book-strip figcaption,
.feature-figure figcaption,
.conference-figure figcaption {
  margin-top: 10px;
  color: #6f6253;
  font-size: 12px;
  line-height: 1.6;
  text-align: center;
}

.feature-figure {
  padding: 20px;
  background:
    linear-gradient(135deg, rgba(249, 244, 235, 0.8), rgba(255, 255, 255, 0) 48%),
    linear-gradient(180deg, rgba(255, 251, 246, 0.96), rgba(255, 255, 255, 1));
  border: 1px solid rgba(179, 145, 101, 0.18);
  border-radius: 10px;
}

.feature-figure figcaption {
  font-size: 13px;
}

.page-section--conference {
  padding: 26px 22px 10px;
  border-radius: 10px;
  background: linear-gradient(180deg, rgba(255, 250, 244, 0.95), rgba(255, 255, 255, 1));
  border: 1px solid rgba(179, 145, 101, 0.16);
}

.conference-grid {
  display: grid;
  gap: 20px;
}

.conference-grid--top {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-bottom: 20px;
}

.conference-figure--wide img {
  max-width: 760px;
  margin: 0 auto;
}

@media (max-width: 900px) {
  .intro-grid,
  .conference-grid--top {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .feature-figure,
  .page-section--conference {
    padding: 14px;
  }
}
</style>
